"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1601))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:45:00.148Z
 */
export const PartyPopper = createSVGIcon(
  <>
    <path
      d="M3.68237 22.6286L15.1338 18.372C15.4719 18.2512 15.7745 18.0477 16.0139 17.7801C16.2534 17.5125 16.4221 17.1893 16.5047 16.8399C16.5873 16.4904 16.5813 16.1259 16.487 15.7794C16.3928 15.4329 16.2134 15.1155 15.9652 14.856L8.76522 7.65599C8.50576 7.40777 8.18833 7.22839 7.84184 7.13417C7.49534 7.03994 7.13079 7.03387 6.78135 7.1165C6.43191 7.19913 6.10868 7.36785 5.84109 7.60728C5.5735 7.84672 5.37004 8.14928 5.24923 8.48742L0.992654 19.9388C0.844756 20.3147 0.809832 20.7257 0.892172 21.1211C0.974512 21.5166 1.17053 21.8794 1.45617 22.165C1.7418 22.4507 2.10462 22.6467 2.50009 22.729C2.89556 22.8114 3.30647 22.7765 3.68237 22.6286V22.6286Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4858 12.2177C19.722 11.7985 18.8317 11.6718 17.9813 11.8611"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5826 7.33542C17.048 6.59912 17.2308 5.71902 17.0968 4.85828"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6411 1.23599C13.2534 3.09321 13.1705 5.10956 12.4079 6.91028"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.1431 5.62112C23.1431 5.84845 23.0528 6.06647 22.892 6.22721C22.7313 6.38796 22.5133 6.47826 22.2859 6.47826C22.0586 6.47826 21.8406 6.38796 21.6798 6.22721C21.5191 6.06647 21.4288 5.84845 21.4288 5.62112C21.4288 5.39379 21.5191 5.17577 21.6798 5.01503C21.8406 4.85428 22.0586 4.76398 22.2859 4.76398C22.5133 4.76398 22.7313 4.85428 22.892 5.01503C23.0528 5.17577 23.1431 5.39379 23.1431 5.62112Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "PartyPopper",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
